import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const userInitSelector = (state: State) => state.userInit.entities;
export const userInitStatusSelector = (state: State) => state.userInit.status;

export const userInitLoadedSelector = isLoaded(userInitStatusSelector);
export const userInitRejectedSelector = isRejected(userInitStatusSelector);
export const userInitPendingSelector = isPending(userInitStatusSelector);
export const shouldLoadUserInitSelector = shouldLoad(userInitStatusSelector);
